import { render, staticRenderFns } from "./PromotionBanner.vue?vue&type=template&id=63cbd570"
import script from "./PromotionBanner.vue?vue&type=script&lang=js"
export * from "./PromotionBanner.vue?vue&type=script&lang=js"
import style0 from "./PromotionBanner.vue?vue&type=style&index=0&id=63cbd570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports